import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from 'axios'; // Import Axios

const ViewComplaint = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    // Fetch data from the API using Axios and update the state
    axios.get("https://apimlm.bloomitsolutions.in/auth/getComplaints")
      .then((response) => setProducts(response.data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <section>
      <div className="container-fluid">
        <div className="row">


          <div className="col-lg-12 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>View Complaints</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>View Complaints</h4>
                </div>

                <div className="card-body">
                  {/* ===========================Search start========================== */}

                  <div className="col-lg-12 ">
                    <div className="row text-end">
                      <div className="col-lg-6"></div>
                      <div className="col-lg-3">
                        <label for="exampleInputPassword1" class="form-label">
                          Search:
                        </label>
                      </div>

                      <div className="col-lg-3">
                        <input
                          type="password"
                          class="form-control"
                          placeholder="User ID"
                          id="exampleInputPassword1"
                        />
                      </div>
                    </div>
                  </div>

                  {/* ===========================Search end========================== */}

                  {/* ============================table start============== */}

                  <div className="col-lg-12 mt-3">
                    <div className="table-responsive">
                      <table className="table table-bordered  mb-0 text-nowrap">
                        <thead>
                          <tr>
                            <th>Sl.No</th>
                            <th>Email</th>
                            <th>Description</th>
                            <th>User Id</th>
                            <th>Vendor Id</th>
                            {/* <th>Reason</th> */}
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((product, index) => (
                            <tr key={index}>
                              <td className="text-dark">{index + 1}</td>
                              <td>{product.email}</td>
                              <td>{product.description}</td>
                              <td>{product.userId}</td>
                              <td>{product.vendorId}</td>
                              <td>{product.status}</td>
                              {/* <td> */}
                                {/* <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                >
                                  Update 
                                </button>
                                <button type="button" className="btn btn-sm btn-danger">
                                  Delete
                                </button> */}
                              {/* </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ==================react pagination================================= */}

                  {/* <div className="mb-4 mt-4">
                        <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination  justify-content-center"}
                            pageClassName={"page-item "}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            activeClassName={"active primary"}
                        />
                    </div> */}

                  {/* ==================react pagination================================= */}
                  {/* </div> */}

                  {/* ============================table end============== */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ViewComplaint;
